import React, { forwardRef } from 'react';

import { START_OF_DAY, END_OF_DAY } from '@vlabs/shared/config';
import { DateInput } from '@vlabs/uikit/components/controls/date-input/DateInput';
import { parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';

import st from './popovers.module.sass';
import { useUserListFilters } from '../useUserListPageFilters';

function LastLoginDateFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useTranslation();
  const { filters, updateFilters } = useUserListFilters();

  return (
    <PopoverWithButton
      {...props}
      data-testid="last_login_time"
      onClickReset={() => updateFilters({
        last_login_at__gte: undefined,
        last_login_at__lt: undefined,
      })}
      ref={ref}
    >
      <div className={st.DateInputWrapper}>
        <DateInput
          enableTime
          id="last_login_at__gte"
          isClearable
          label={t('от') as unknown as string}
          name="last_login_at__gte"
          onChange={([last_login_at__gte]: Date[]) => updateFilters({
            last_login_at__gte: last_login_at__gte?.toISOString(),
          })}
          options={START_OF_DAY}
          value={filters.last_login_at__gte ? parseISO(filters.last_login_at__gte) : ''}
        />
      </div>
      <div className={st.DateInputWrapper}>
        <DateInput
          enableTime
          id="last_login_at__lt"
          isClearable
          label={t('до') as unknown as string}
          name="last_login_at__lt"
          onChange={([last_login_at__lt]: Date[]) => updateFilters({
            last_login_at__lt: last_login_at__lt?.toISOString(),
          })}
          options={END_OF_DAY}
          value={filters.last_login_at__lt ? parseISO(filters.last_login_at__lt) : ''}
        />
      </div>
    </PopoverWithButton>
  );
}

const LastLoginDateFilterPopoverWithRef = forwardRef(LastLoginDateFilterPopover);
export { LastLoginDateFilterPopoverWithRef as LastLoginDateFilterPopover };
